var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "doge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RenBridge_v2-icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "doge-icon",
    transform: "translate(-3.000000, -3.000000)",
    fill: "#C2A633",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C16.97061,3 21,7.02939 21,12 C21,16.97061 16.97061,21 12,21 C7.02939,21 3,16.97061 3,12 C3,7.02939 7.02939,3 12,3 Z M12.0965751,7.13280534 L9.09417,7.13289 L9.09417,11.4663 L7.94532,11.4663 L7.94532,12.52776 L9.09426,12.52776 L9.09426,16.8609 L12.3537,16.8609 C12.3537,16.8609 16.93659,17.24502 16.93659,12.07821 C16.93659,7.37196 13.1786425,7.14117296 12.0965751,7.13280534 Z M12.216,8.931 C12.69696,8.931 15.1167,9.12459 15.1205745,12.11322 C15.1242252,14.935815 12.8955156,15.0577278 12.3558952,15.0625619 L10.93008,15.0627255 L10.93008,12.52767 L12.95319,12.52767 L12.95319,11.46621 L10.93008,11.46621 L10.93008,8.931 Z",
    id: "doge"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoge);
export default __webpack_public_path__ + "static/media/doge.0f4ded23.svg";
export { ForwardRef as ReactComponent };